import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function DefaultLoading({ pages, message, context = 'general', transparent = false }) {
  const [showSlowMessage, setShowSlowMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowSlowMessage(true), 9000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`flex flex-col items-center justify-center relative overflow-hidden ${transparent ? 'h-full' : 'flex-1 min-h-0'} gch-page`}
      style={{
        background: transparent ? 'transparent' : 'var(--admin-bg-primary)',
        fontFamily: '"Inter", sans-serif',
        minHeight: transparent ? undefined : '100dvh',
        width: '100%',
      }}
      role="status"
      aria-live="polite"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        transition={{
          opacity: { duration: 0.3 },
          scale: { duration: 0.3 },
        }}
        className="w-8 h-8 rounded-full border-4 border-[var(--admin-accent-light)] border-t-[var(--admin-accent)] animate-spin"
        aria-hidden="true"
      />
      <span className="sr-only">Loading</span>
      {showSlowMessage && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mt-4 text-sm gch-text-secondary"
        >
          Taking longer than expected...
        </motion.p>
      )}
    </div>
  );
}
